import { render, staticRenderFns } from "./send-whats-app.vue?vue&type=template&id=17365793&"
import script from "./send-whats-app.vue?vue&type=script&lang=js&"
export * from "./send-whats-app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports